/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import Skeleton from 'antd/lib/skeleton';
import { Tooltip } from 'antd';
import { useMapContext } from '../context/map-context';
import { IRecordMap } from '../../../../store/modules/report/i-report';

interface IProps {
  loading: boolean;
  item:IRecordMap
}
export const AssetItem:React.FC<IProps> = ({ item, loading }) => {
  const { onShowAssetDetails, flyToMarker } = useMapContext();

  return (
    loading ? (
      <div
        style={{
          height: '60px',
          width: '100%',
          borderTop: '1px solid #F7F8FA',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0 10px',
        }}
      >
        <div style={{ width: '3px', height: '100%', backgroundColor: 'blue' }} />
        <div style={{
          width: '100%', padding: '10px', display: 'flex', justifyContent: 'space-between',
        }}
        >
          <div>
            <Skeleton.Input active size="small" style={{ width: '50px', marginBottom: '8px' }} />
            <div style={{ display: 'flex', gap: '5px' }}>
              <Skeleton.Input active size="small" style={{ width: '30px' }} />
              <Skeleton.Input active size="small" style={{ width: '30px' }} />
              <Skeleton.Input active size="small" style={{ width: '50px' }} />
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Skeleton.Input active size="small" style={{ width: '60px', marginBottom: '8px' }} />
            <Skeleton.Input active size="small" style={{ width: '100px' }} />
          </div>
        </div>
        <div style={{ padding: '5px', display: 'flex', alignItems: 'center' }}>
          <Skeleton.Avatar active shape="square" size="small" style={{ width: '16px', height: '16px' }} />
        </div>
      </div>
    ) : (
      <div
        onClick={() => {
          onShowAssetDetails(item);
          if ((item?.X && item?.Y) || (item?.x && item?.y)) {
            flyToMarker(Number(item.X || item.x), Number(item.Y || item.y), item.uniqueKey);
          }
        }}
        style={{
          height: '60px',
          width: '100%',
          borderTop: '1px solid #E1E3E8',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        className="hover-background"
      >
        <div style={{ width: '3px', height: '100%', backgroundColor: '#3800EE' }} />
        <div style={{
          padding: '12px 16px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{
              display: 'flex', gap: '5px', fontSize: '14px', width: '100%',
            }}
            >
              <span style={{ color: '#4E4F52' }}>EPC:</span>
              <Tooltip title={item.EPC || item.UID}>
                <span style={{
                  color: '#3800EE',
                  textDecorationLine: 'underline',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  width: '270px',
                  direction: 'rtl',
                  textAlign: 'left',
                  display: 'inline-block',
                }}
                >
                  {item.EPC || item.UID}
                </span>
              </Tooltip>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ whiteSpace: 'nowrap', fontSize: '12px', color: '#4E4F52' }}>
              Zone:
              {' '}
              {item.Zone}
            </span>
            { item?.Time && (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <span style={{ whiteSpace: 'nowrap', fontSize: '12px', color: '#81848C' }}>{item.Time}</span>
              </div>
            )}
          </div>
        </div>

        <div />
      </div>
    )
  );
};
